module.exports = __webpack_public_path__ + "static/media/lora_indoor_modbus.9282eb67.md";